import { HIDE_SUBSCRIPTION_MODAL, SHOW_SUBSCRIPTION_MODAL } from './actionsTypes';
import { SubscriptionModalActions, SubscriptionModalState } from './types';

const initialState: SubscriptionModalState = {
  isOpen: false,
  isLoading: false,
};

export const subscriptionModalReducer = (
  state: SubscriptionModalState = initialState,
  action: SubscriptionModalActions,
): SubscriptionModalState => {
  switch (action.type) {
    case SHOW_SUBSCRIPTION_MODAL:
      return {
        ...state,
        isOpen: true,
      };
    case HIDE_SUBSCRIPTION_MODAL:
      return {
        ...state,
        isOpen: false,
      };
    default:
      return state;
  }
};
